import blurElementOnParentContextClick from '../utils/helpers/blur-element-on-parent-context-click';
import unselectElementOnParentContextClick from '../utils/helpers/unselect-element-on-parent-context-click';

const parentContextClickHandler = (e) => {
  blurElementOnParentContextClick(e);
  unselectElementOnParentContextClick(e);
};

export default parentContextClickHandler;
